import BaseController from 'app/src/controllers/base/BaseController';
import PaymentServiceDegradationView from 'app/src/views/payments/PaymentServiceDegradationView';

export default class PaymentServiceDegradationViewController extends BaseController {
  constructor() {
    super();

    this.view = new PaymentServiceDegradationView();
  }
}
